import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Message, TreeNode } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { CategoriaPermissaoAgrupada } from 'src/app/admihair/api/dto/categoria-permissao-agrupada';
import { CategoriaPermissaoService } from 'src/app/admihair/service/categoria-permissao.service';



@Component({
  selector: 'app-usuario-empresa-detalhar',
  templateUrl: './usuario-empresa-detalhar.component.html',
  styleUrls: ['./usuario-empresa-detalhar.component.scss']
})
export class UsuarioEmpresaDetalharComponent implements OnInit {

  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  exibirSpinnerTree: boolean = false;
  @Output() emissor = new EventEmitter();
  @Input() empresa?: Empresa;
  @Input() id?: number;
  usuario?: Usuario;


  colunasTreeTableSalvas: any[] = [];
  categoriasTreeTableSalvas: TreeNode[] = [];
  categoriasTreeTableSalvasSelecionada: TreeNode[] = [];

  constructor(private categoriaPermissaoService: CategoriaPermissaoService,
    private usuarioService: UsuarioService,
    private erroService: ErroService
  ) { }

  ngOnInit(): void {
    this.exibirSpinnerTree = true;
    this.inicializarColunas();
    this.carregarUsuarioPorId();
  }

  inicializarColunas() {
    this.colunasTreeTableSalvas = [
      { field: 'descricao', header: 'Permissão' }
    ];
  }


  carregarUsuarioPorId() {
    this.usuarioService.buscarPorId(this.id).subscribe({
      next: (data: Usuario) => {
        this.usuario = data;
        this.messagemVisivel = false;
        this.listarCategoriasSalvas();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  listarCategoriasSalvas() {
    this.categoriaPermissaoService.listarAdicionadasPorUsuarioETipoEmpresa(this.empresa?.id, this.usuario?.id).subscribe({
      next: (data: CategoriaPermissaoAgrupada[]) => {
        this.exibirSpinnerTree = false;
        this.categoriasTreeTableSalvas = this.converterParaTreeNode(data);
      },
      error: (err: any) => {
        this.exibirSpinnerTree = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }
 

  converterParaTreeNode(categorias: CategoriaPermissaoAgrupada[]): TreeNode[] {
    return categorias.map(categoria => ({
      data: categoria,
      children: categoria.permissoes ? categoria.permissoes.map(permissao => ({
        data: permissao,
        leaf: true
      })) : []
    }));
  }

 

  voltar() {
    this.emissor.emit({
      modo: 'LISTAR'
    });
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
